/** Nutrients tracked per 100 g (PLAN.md §4, §6); salt is derived from sodium (Na × 2.5). */
export const NUTRIENT_KEYS = [
  'kcal',
  'protein',
  'fat',
  'sat_fat',
  'carbs',
  'sugar',
  'fiber',
  'salt',
] as const;
export type NutrientKey = (typeof NUTRIENT_KEYS)[number];
export type Nutrients = Record<NutrientKey, number>;
